import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useLocation, useNavigate } from 'react-router-dom';
import { ListChecks } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { getApiUrl } from '../utils/api';
import { depuisCache } from '../lib/cache360';

const DIRECTION = ['owner', 'manager', 'directeur', 'gerant', 'gérant', 'admin', 'patron', 'direction'];

// Rappel discret : la configuration guidée peut être reprise à tout moment (étape 5 du parcours de souscription).
export const MiseEnRouteBanner = () => {
  const { user } = useAuth(); const nav = useNavigate(); const { pathname } = useLocation();
  const [state, setState] = useState(() => depuisCache(`${getApiUrl()}/mise-en-route`) ?? null);  // LOT 79 · posé avec la page, pas après
  const eligible = user && !user.demo_mode && DIRECTION.includes(user.role);
  useEffect(() => {
    if (!eligible) return undefined;
    const load = () => axios.get(`${getApiUrl()}/mise-en-route`, { withCredentials: true }).then((r) => setState(r.data)).catch(() => setState(null));
    load();
    window.addEventListener('mise-en-route:refresh', load);
    return () => window.removeEventListener('mise-en-route:refresh', load);
  }, [eligible]);
  if (!state || state.completed || state.done >= state.total || pathname.endsWith('/mise-en-route')) return null;
  const slug = user.tenant_slug || user.tenant_id;
  const next = state.steps.find((s) => !s.done);
  return <button type="button" onClick={() => nav(`/${slug}/mise-en-route`)} className="w-full text-left px-4 py-2.5 flex flex-wrap items-center gap-3 text-sm bg-[var(--p-f7c948)] text-[var(--encre)]" data-testid="mise-en-route-banner">
    <ListChecks size={16} className="shrink-0" />
    <span className="font-bold">Mise en route · {state.done} sur {state.total} étapes complétées</span>
    {next && <span className="text-[var(--p-5a4a32)]">Prochaine étape : {next.label}</span>}
    <span className="ml-auto font-bold underline underline-offset-2">Continuer →</span>
  </button>;
};
